define('commons/custom-file-input',['jquery'], function( $ ) {

    var CustomFileInput = function( container ) {
        var $container = $(container);
        var $fileInput  = $container.find( 'input' ); 
        var $fileName = $container.find( '.file-name' );

        $fileInput.on( 'change', function( event ) {
            var fileName = $(this).val().split('\\').pop();
            $fileName.html( fileName );  
            $fileName.attr( 'title', fileName );
        });
    };
    
    return CustomFileInput;
});
